import { render, staticRenderFns } from "./BodyAnatomyDelete.vue?vue&type=template&id=7afc4276&scoped=true&"
import script from "./BodyAnatomyDelete.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afc4276",
  null
  
)

export default component.exports